import { render, staticRenderFns } from "./EditPopup.vue?vue&type=template&id=62c3fc80"
import script from "./EditPopup.vue?vue&type=script&lang=js"
export * from "./EditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports